import { z } from 'zod';

/**
 * Integraciones por empresa. Una empresa puede tener N conexiones de Instantly (§6.1).
 *
 * `hunter` y `apify` se sacaron del contrato el 2026-09-25 (Hunter y Apify/WF07 apagados en
 * las 3 instancias de n8n; nunca se usaron como `tenant_integrations` — verificado en
 * producción que la tabla no tenía ninguna fila con esos `kind`, así que el retiro es seguro).
 * La columna/CHECK de la base NO se tocó (queda tolerante a esos valores por si algún día se
 * reactivan) — esto es sólo el contrato de la API/UI. Ver CLAUDE.md y docs/decisions.md.
 */
export const INTEGRATION_KINDS = [
  'instantly',
  'gmail',
  'gemini',
  'sheets',
  'leadmagic',
  'scraperapi',
  'telegram',
  /** DB Postgres de un stack viejo (etapa 1): secreto = connection string read-only. */
  'legacy_db',
  /** API pública de una instancia n8n: secreto = X-N8N-API-KEY, config.baseUrl. */
  'n8n',
] as const;
export const integrationKindSchema = z.enum(INTEGRATION_KINDS);
export type IntegrationKind = z.infer<typeof integrationKindSchema>;

/** Lo que ve el browser: el secreto NUNCA vuelve, sólo "configurado" + últimos 4. */
export const integrationSchema = z.object({
  id: z.uuid(),
  tenantId: z.uuid(),
  kind: integrationKindSchema,
  label: z.string(),
  config: z.record(z.string(), z.unknown()),
  hasSecret: z.boolean(),
  secretLast4: z.string().nullable(),
  status: z.enum(['active', 'disabled']),
  updatedAt: z.string(),
});
export type Integration = z.infer<typeof integrationSchema>;

export const createIntegrationSchema = z.object({
  kind: integrationKindSchema,
  label: z.string().trim().min(1).max(120),
  config: z.record(z.string(), z.unknown()).default({}),
  secret: z.string().min(1).max(8192).optional(),
});
export type CreateIntegration = z.input<typeof createIntegrationSchema>;
